import CollectionQueryBuilder from './CollectionQueryBuilder';

export default CollectionQueryBuilder;
